<template lang="pug">
div
  Header
  |
  ZohoForm.iframe-container.mb-8
//- div
  Header
  |
  .employer
    h3.mt-16.section__title Provide us with more information regarding your company
    |
    p.text-center.mt-4.mb-8
      span If you are a candidate and you are looking for a job in the UK, please fill in 
      |
      NuxtLink.underline(to="https://recruitment.nationbetter.uk/" @click="trackClick()") the candidate’s form
      |
      span .
    |
    ZohoForm.iframe-container.mb-8
</template>

<script setup lang="ts">
const { $amplitude } = useNuxtApp();

const trackClick = () => {
  if (!$amplitude) return;
  $amplitude.track('The Candidate’s Form Link Clicked', {
    page: window.location.pathname,
    destination: 'https://recruitment.nationbetter.uk/',
  });
};
</script>

<style lang="sass" scoped>
.employer
  margin-top: 100px
  margin-bottom: 100px
  
h3 
  color: #074033
  font-size: 40px
  font-style: normal
  font-weight: 800
  line-height: 47px
  text-align: center

.iframe-container
  display: flex
  justify-content: center

  &:deep(iframe)
    width: 50%
    border-radius: 8px
    height: 1024px

@media (max-width: 1024px)
  .iframe-container
    &:deep(iframe)
      width: 100%
      height: 800px

  .section
    padding-left: 5vw
    padding-right: 5vw
</style>